const getSessionEndTime = (
  appointment: AppointmentMetaData,
  newStart: string,
) => {
  const duration =
    new Date(appointment.appointment_end).getTime() -
    new Date(appointment.appointment_start).getTime();

  const newEnd = new Date(newStart).getTime() + duration;
  return new Date(newEnd).toISOString();
};

export default getSessionEndTime;
